module.exports = __webpack_public_path__ + "img/flt_pt_rnd_setsku.prt.54af2301.jpg";